/*
 * @Author: hfxie
 * @Date: 2022-08-17 17:23:53
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-12-01 17:02:26
 * @Description: file content
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters.js";
import CONSTNAME from "@/ConstName.js";

function createStore() {
  const store = new Vuex.Store({
    state: {
      // 线上数据
      data: {
        list: {
          header: {
            /* key: [ // 表头配置 *示例一条*
              {
                "id": "1406548060833592320", // 唯一ID
                "colAlign": "center", // 对齐形式
                "colWidth": 100, // 宽度
                "colCaption": "职位", // 显示内容
                "colName": "number", // ??后端字段
                "fontSize": 12, // 字体大小
              },

            ], */
          },
          info: [ // 筛选后数据 *示例一条*
            /* {
              id: "1", // 唯一ID
              name: "工程师", // 一级·类别名称
              nameHeader: "姓名", // 一级·固定配置表头名称
              cellKey: "key1", // 一级·配置表头Key
              isExpand: true, // 一级·展开状态
              headerShow: true, //  一级·展示表头状态
              path: [0],
              child: [ // 二级·行 *示例一条*
                {
                  id: "1-1", // 唯一ID
                  name: "卢洪斌", // 二级·类别名称
                  isExpand: true, // 二级·展开状态
                  draggable: true, // 二级·支持拖拽状态
                  isAddTempClass: false, // hover是否可添加操作
                  color: "blue", // 二级·行文字颜色
                  rightWord: "排", // 二级·行头标签字符内容
                  rightWordColor: "#FF0000", // 二级·行头标签字符颜色
                  cellList: [ // 二级·行 右侧可配置项单元格内容 *示例一条*
                    {
                      "colIndex": 0, // 下标顺序 从0开始递增
                      "val": "LE", // 二级·显示内容
                      "desc": "", // ??
                      "enable": true, // ??
                      "cellTag": "", // ??
                      "color": "#ffff00", // 二级·列单元格文字颜色(优先级高于行文字颜色)
                    },

                  ],
                  detail: [ // 三级·子详情列表信息 *示例一条*
                    {
                      id: "1-1-1", // 唯一ID
                      label: "飞机工作｜B-2505(RW)", // 三级·显示内容·左侧
                      value: "2021/6/2~2021/6/7", // 三级·显示内容·右侧
                    },

                  ],
                  level: 0,
                  path: [0, 0],
                  color: "red",
                  menus: [
                    {
                      cbName: "智能推荐",
                      cbNumber: "cbNumber_intelligrecommend",
                      disabled: false,
                      divided: false,
                      hidden: false,
                    },
                  ],
                  child: [], // 子集·嵌套二级整体对象结构
                  nameBold: false, // 是否行头加粗
                  nameFontSize: "12px", // 行头字体大小
                },

              ],
            }, */

          ],
        },
        config: { // 通用配置
          placehold: "", // 搜索框提示内容
          filterStatus: false, // true: 展开 false: 折叠

        },
        /* filter: [ // 筛选配置 *示例一条·筛选大块*
          {
            id: "3-1", // 唯一ID
            title: "人员分类筛选", // 类别名称
            actions: [ // 类别具体选项 *示例一条*
              {
                id: "3-1-1", // 唯一ID
                label: "行业经理", // 选项名称
                status: false, // 当前选项的值
              },

            ],
          },

        ], */
      },
      dataLoadingStatus: false, // 控件数据加载中
      // demo 本地状态数据
      local: {
        filterStr: "",
        totalWidth: 320,
        leftWidth: 148,
      },
      uuid: "kd",
      noDataMsg: "暂无数据",
    },
    mutations: mutations,
    actions: actions,
    modules: {},
    getters: getters,
  });
  return store;
}


export default createStore;

